import type { ReactNode } from 'react';
import { cx } from '@/utils/cn';

interface SectionHeadingProps {
  id?: string;
  eyebrow: string;
  title: string;
  description?: string;
  className?: string;
}

export function SectionHeading({
  id,
  eyebrow,
  title,
  description,
  className,
}: SectionHeadingProps) {
  return (
    <header className={cx('section-heading', className)}>
      <p className="section-heading__eyebrow">{eyebrow}</p>
      <h2 id={id} className="section-heading__title">
        {title}
      </h2>
      {description ? <p className="section-heading__description">{description}</p> : null}
    </header>
  );
}

interface ContainerProps {
  children: ReactNode;
  narrow?: boolean;
  className?: string;
}

export function Container({ children, narrow = false, className }: ContainerProps) {
  return (
    <div className={cx('container', narrow && 'container--narrow', className)}>{children}</div>
  );
}
